// extracted by mini-css-extract-plugin
export default {"facet":"Facet_facet__DwoJW","count":"Facet_count__LZ4H1","checkbox":"Facet_checkbox__Mo2vS","checkedIcon":"Facet_checkedIcon__N2-a9"};